import articleTranslates from './article-i18n';

export default function () {
  return {
    ...articleTranslates()
  };
}
